/* eslint-disable react/prop-types */
import React from 'react';
import Certifications from './certifications';
import Specialties from './specialties/index';
import SubSpecialties, { type SubSpecialty } from './sub_specialties/index';
import Organizations from './organizations';
import Departments, { type Department } from './departments/index';
import Regions, { type Region } from './regions';

export interface BrokerTitlesProps {
  certifications: any;
  departments: Department[];
  organizations: any;
  regions: Region[],
  showDepartments?: boolean;
  showRegions?: boolean;
  specialties: any;
  subSpecialties: SubSpecialty[];
}

export default function BrokerTitles({
  certifications,
  departments,
  organizations,
  regions,
  showDepartments,
  showRegions,
  specialties,
  subSpecialties
}: BrokerTitlesProps) {
  return (
    <>
      <Certifications certifications={certifications}/>
      <Specialties
        specialties={specialties}
      />
      <SubSpecialties subSpecialties={subSpecialties}/>
      <Organizations organizations={organizations}/>
      {showDepartments && <Departments departments={departments}/>}
      {showRegions && <Regions regions={regions}/>}
    </>
  );
}
